import React from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck, Download, BookOpen } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
export function HeroSection() {
  const cartLink = 'https://carlosponte.com/cart/add?id=56937498575173&quantity=1';
  return <section className="relative pt-10 pb-6 md:pt-24 md:pb-20 overflow-hidden" data-id="element-198">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 opacity-10 pointer-events-none" data-id="element-199">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] rounded-full bg-gold-400 blur-[100px]" data-id="element-200" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[500px] h-[500px] rounded-full bg-burgundy-600 blur-[100px]" data-id="element-201" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-202">
        <div className="flex flex-col items-center text-center" data-id="element-203">
          {/* Text Column - Centered for better CRO focus */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="flex flex-col space-y-4 md:space-y-6 max-w-3xl mx-auto" data-id="element-204">
            {/* Trust Badges */}
            <div className="flex flex-wrap justify-center gap-2 items-center" data-id="element-205">
              <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-gold-100 text-gold-800 border border-gold-300" data-id="element-206">
                <Star className="w-3 h-3 mr-1 fill-gold-600 text-gold-600" data-id="element-207" />
                4.9/5 Calificación
              </span>
              <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-navy-50 text-navy-800 border border-navy-200" data-id="element-208">
                <ShieldCheck className="w-3 h-3 mr-1" data-id="element-209" />
                Verificado
              </span>
            </div>

            {/* Headline */}
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight" data-id="element-210">
              Comprende los{' '}
              <span className="text-burgundy-600 highlight-gold" data-id="element-211">
                66 Libros
              </span>{' '}
              de la Biblia en menos de{' '}
              <span className="text-burgundy-600 highlight-gold" data-id="element-212">7 dias</span>{' '}
              con un viaje visual
            </h1>

            {/* Subheadline */}
            <p className="text-base md:text-xl text-gray-700 leading-relaxed max-w-2xl mx-auto" data-id="element-213">
              Descubre{' '}
              <span className="font-bold text-gray-900" data-id="element-214">EXACTAMENTE</span> dónde
              ocurrió cada acontecimiento bíblico y logra con estas{' '}
              <span className="font-bold text-burgundy-700 highlight-warm" data-id="element-215">
                +500 Paginas
              </span>{' '}
              de contexto visual que{' '}
              <span className="italic text-gray-800" data-id="element-216">
                cada versículo cobre vida frente a tus ojos.
              </span>
            </p>

            {/* Product Image - Optimized loading */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="w-full max-w-2xl mx-auto rounded-xl overflow-hidden shadow-xl border-2 border-gold-200 my-4" data-id="element-217">
              <img src="https://cdn.magicpatterns.com/uploads/19Xys8wy9SaSEhaVb8peeU/20260225_1349_Image_Generation_simple_compose_01kjav77w8f2wrzq7hhc4dkpn4.png" alt="Biblia Visual — Guía Visual Completa con todos los bonos incluidos" className="w-full h-auto object-cover" width="800" height="600" loading="eager" fetchPriority="high" data-id="element-218" />
            </motion.div>

            {/* Feature Badges */}
            <div className="flex flex-wrap justify-center gap-3 text-sm font-medium text-gray-600" data-id="element-219">
              <span className="flex items-center" data-id="element-220">
                <BookOpen className="w-4 h-4 mr-1 text-gold-600" data-id="element-221" /> 66 Libros
              </span>
              <span className="flex items-center" data-id="element-222">
                <Download className="w-4 h-4 mr-1 text-gold-600" data-id="element-223" /> 500+ Páginas
              </span>
              <span className="flex items-center" data-id="element-224">
                <Star className="w-4 h-4 mr-1 text-gold-600" data-id="element-225" /> 280+ Imágenes HD
              </span>
            </div>

            {/* CTA Area */}
            <div className="pt-4 flex flex-col items-center w-full" data-id="element-226">
              <a href={cartLink} className="group relative inline-flex items-center justify-center w-full md:w-auto px-8 py-4 text-lg font-bold text-white transition-all duration-200 bg-gradient-to-r from-gold-500 to-amber-600 rounded-lg hover:from-gold-600 hover:to-amber-700 shadow-lg hover:shadow-gold-500/50 transform hover:-translate-y-1 will-change-transform" data-id="element-227">
                <span className="absolute inset-0 w-full h-full mt-1 ml-1 transition-all duration-200 ease-in-out bg-gold-900 rounded-lg group-hover:mt-0 group-hover:ml-0 opacity-30" data-id="element-228"></span>
                <span className="relative flex items-center" data-id="element-229">
                  QUIERO MI BIBLIA VISUAL »
                </span>
              </a>

              <div className="mt-3 flex items-center justify-center space-x-4 text-xs text-gray-500" data-id="element-230">
                <span className="flex items-center" data-id="element-231">
                  <ShieldCheck className="w-3 h-3 mr-1" data-id="element-232" /> Garantía 30 días
                </span>
                <span className="flex items-center" data-id="element-233">
                  <Download className="w-3 h-3 mr-1" data-id="element-234" /> Descarga inmediata
                </span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}